import { useEffect, useState } from "react"

import style from "../../sass/components/popups/shipment-item-popup.module.scss"
import { useSelector } from "react-redux"
import { selectProductTypes } from "./productTypeSelectSlice"
import { findClosestProductType } from "./findClosestProductType"
import ProductTypesList from "./ProductTypesList"
import { selectShipmentItemsUpdatingStatus } from "../shipment/ShipmentItems/shipmentItemsSlice"
import { useTranslation } from "react-i18next"

const SelectProductType = ({setState, state}) => {
    const {t, i18n} = useTranslation()
    const productListFromState = useSelector(selectProductTypes)
    const [inputValue, setInputValue] = useState("")
    const [productList, setProductList] = useState([])
    const [productType, setProductType] = useState("")
    const productNameFiled = i18n.language == "tr" ? "tr-name" : "ru-name" 

    const handleInputChange = (e) => {
        let value = e.target.value

        setInputValue(value);

        if(!value) {
            setProductList([])
            return
        }

        let list = findClosestProductType(value, productListFromState, productNameFiled) ?? [];
        console.log(list)
        setProductList(list);
    }

    useEffect(() => {
        if (productType && productType[productNameFiled]) {
            setInputValue(productType[productNameFiled] ?? "")
            setProductList([])
            setState((prev) => ({
                ...prev,
                "tr-name": productType["tr-name"] ?? "",
                "en-name": productType["en-name"] ?? "",
                "id": productType["product-type-id"] ?? "",
                "gtip-code": productType["gtip-code"] ?? "",
                "item-code": productType["item-code"] ?? "",
                weight: productType["weight"] ?? "",
                warning: productType["warning"] ?? "",
            }))

        }
    }, [productType, setState])

    useEffect(() => {
        if (state && state[productNameFiled]) {
            setInputValue(state[productNameFiled])
        } else {
            setInputValue("")
        }
    }, [state])


  return (
        <div className="flex flex-col gap items-start">
            <span className="text-lg text-gray-600 font-bold text-left mb-1">
                {t("shipment.items.item_popup.product_type.title")}
            </span>
            {" "}
            <span className="text-sm text-gray-600 font-bold text-left mb-1">
                {t("shipment.items.item_popup.product_type.example")}
            </span>
            
            <input
                className={`border text-xs rounded-md p-1 w-full`}
                style={{maxWidth: "400px"}}
                placeholder={t("shipment.items.item_popup.product_type.placeholder")}
                value={inputValue}
                onChange={handleInputChange}
                type="text"
            />
            {productList.length > 0 && (
                <ProductTypesList 
                    inputValue={inputValue}
                    productTypeList={productList} 
                    setProductType={setProductType}
                    productNameFiled={productNameFiled}
                />
            )}
            <div className="text-md text-left text-gray-600 font-bold mt-4">
                {t("shipment.items.item_popup.product_type.subscription")}
            </div>
        </div>
  )
}

export default SelectProductType